import { Controller } from "@hotwired/stimulus"
import {
  applyPdfPageCount,
  directUpload,
  updateUploadedFileLink,
} from "./active_storage/upload_helpers"

// Single-file compact upload (nested form rows, replace-in-place fields).
export default class extends Controller {
  static targets = ["input", "hiddenInput", "button", "linkContainer", "status", "pdfPages"]
  static values = {
    url: String,
  }

  connect() {
    if (!this.hasInputTarget) return

    this.inputTarget.addEventListener("change", this.handleFileSelect.bind(this))
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (!file) return

    this.uploadFile(file)
  }

  async uploadFile(file) {
    if (!this.hasHiddenInputTarget) return

    const delegate = {
      directUploadWillStoreFileWithXHR: (request) => {
        this.showStatus("Uploading...")
        this.hideLinkContainer()

        request.upload.addEventListener("progress", (event) => {
          const progress = Math.round((event.loaded / event.total) * 100)
          this.showStatus(`Uploading ${progress}%`)
        })
      },
    }

    try {
      const blob = await directUpload(file, this.urlValue, delegate)
      this.hiddenInputTarget.value = blob.signed_id

      this.showStatus("Upload complete!")
      if (this.hasButtonTarget) this.buttonTarget.textContent = "Replace"
      if (this.hasLinkContainerTarget) {
        updateUploadedFileLink(this.linkContainerTarget, blob)
      }

      await applyPdfPageCount(blob.signed_id, file, this.element)

      setTimeout(() => {
        this.hideStatus()
        this.showLinkContainer()
      }, 2000)
    } catch (error) {
      this.showStatus("Upload failed.")
      console.error(error)
      setTimeout(() => {
        this.hideStatus()
        this.showLinkContainer()
      }, 2000)
    }
  }

  showStatus(message) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.classList.remove("hidden")
  }

  hideStatus() {
    if (!this.hasStatusTarget) return

    this.statusTarget.classList.add("hidden")
  }

  hideLinkContainer() {
    if (this.hasLinkContainerTarget) {
      this.linkContainerTarget.classList.add("hidden")
    }
  }

  showLinkContainer() {
    if (this.hasLinkContainerTarget) {
      this.linkContainerTarget.classList.remove("hidden")
    }
  }
}
